import { authFetch, BASE_BACKEND_URL } from '../../auth'
import * as apiStatusCodes from '../../constants/apiStatusCodes'

////// Stops fetchs when page is changed
const abortController = new AbortController()
const abortCurrentFetchs = () => {
  abortController.abort('Fetch Aborted by User.')
}
window.addEventListener('beforeunload', abortCurrentFetchs)
//////

const sendApiRequest = (method, url, params) => {
  try {
    return authFetch(url, {
      method: method,
      signal: abortController.signal,
      body: JSON.stringify(params)
    })
  } catch (error) {
    if (error !== 'Fetch Aborted by User.') {
      console.error('Error:', error)
    }
  }
}

export const handleErrors = (response) =>
  // eslint-disable-next-line no-undef
  new Promise((resolve, reject) => {
    if (!response || (response.status !== apiStatusCodes.OK && response.status !== apiStatusCodes.CREATED)) {
      reject(response)
    } else {
      resolve(response)
    }
  })

export const getAllUsers = (query = '', page = 1, per_page = 25, filters = [], active = []) => {
  const url = `${BASE_BACKEND_URL}/ubiqua_app_users?q=${query}&filters=${filters}&active=${active}&page=${page}&per_page=${per_page}`

  return sendApiRequest('GET', url)
}

export const getFeatureRoles = (query = '', page = 1, per_page = 25) => {
  const url = `${BASE_BACKEND_URL}/ubiqua_app_feature_roles?q=${query}&page=${page}&per_page=${per_page}`
  return sendApiRequest('GET', url)
}

export const getUserConfig = (uid) => {
  const url = `${BASE_BACKEND_URL}/ubiqua_app_users/${encodeURIComponent(uid)}`

  return sendApiRequest('GET', url)
}

export const getBusiness = () => {
  const url = `${BASE_BACKEND_URL}/admin/businesses`
  return sendApiRequest('GET', url)
}

export const updateUserInfo = (uid, value) => {
  const url = `${BASE_BACKEND_URL}/ubiqua_app_users/${encodeURIComponent(uid)}`

  const params = {
    active: value.active,
    email: value.email,
    full_name: value.name,
    route_db_ref: value.internalCode?.trim() || null,
    mobile: value.mobile,
    warehouse_uid: value.warehouse,
    roles: value.role
  }
  return sendApiRequest('PUT', url, params)
}

export const createUserInfo = (user, config) => {
  const url = `${BASE_BACKEND_URL}/ubiqua_app_users`
  const configFlags = Object.entries(config).map((e) => ({ [e[0]]: e[1].value }))
  const params = {
    config: configFlags,
    active: user.active,
    email: user.email,
    full_name: user.name,
    uid: user.code,
    route_db_ref: user.internalCode?.trim() || null,
    warehouse_uid: user.warehouse,
    roles: user.role,
    mobile: user.mobile
  }
  return sendApiRequest('POST', url, params)
}

export const resetPassword = (user) => {
  const url = `${BASE_BACKEND_URL}/ubiqua_app_users/${encodeURIComponent(user.uid)}/reset_access`
  return sendApiRequest('POST', url, {})
}

export const getUserGeofence = (uid, page = 1, perPage = 20) => {
  const url = `${BASE_BACKEND_URL}/ubiqua_app_users/${encodeURIComponent(uid)}/geofence?page=${page}&per_page=${perPage}`

  return sendApiRequest('GET', url)
}

export const updateUserGeofence = (uid, geoMaxDistanceInMeter, comments) => {
  const url = `${BASE_BACKEND_URL}/ubiqua_app_users/${encodeURIComponent(uid)}/geofence`
  const params = {
    geo_max_distance_in_meter: geoMaxDistanceInMeter,
    comments
  }

  return sendApiRequest('PATCH', url, params)
}

export const updateUserGeofenceBlock = (uid, geofenceBlockEnabled, comments = 'Bloqueo por geocerca') => {
  const url = `${BASE_BACKEND_URL}/ubiqua_app_users/${encodeURIComponent(uid)}/geofence`
  const params = {
    geofence_block_enabled: geofenceBlockEnabled,
    comments
  }

  return sendApiRequest('PATCH', url, params)
}

export const clearUserGeofence = (uid, comments) => {
  const url = `${BASE_BACKEND_URL}/ubiqua_app_users/${encodeURIComponent(uid)}/geofence`

  return sendApiRequest('DELETE', url, { comments })
}

export const getQueryState = () => {
  if (window.location.href.indexOf('query') >= 0) {
    return decodeURI(
      window.location.href.split('query=')[window.location.href.split('query=').length - 1]
    )
  } else {
    return ''
  }
}

export const getFormattedDate = (date) => {
  return new Date(date).toLocaleString()
}
